<ng-container *ngIf="!shouldDisplay; else BooleanDisplayTemplate"></ng-container>
<ng-template #BooleanDisplayTemplate>
<div class="boolean-image-wrapper">
    <img class="boolean-image" [src]="imageSource" [alt]="imageAlt" />
</div>
</ng-template>
